import {
  TransmittalDto,
  TransmittalPdfOptionDto,
} from 'src/api/FiretrolApiClient';
import { transmittalApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleQueries } from 'src/api/queries/workflowModules/createModuleQueries';
import { queryKeys } from 'src/api/queries/queryKeys';

const queries = createModuleQueries<TransmittalDto, TransmittalPdfOptionDto>({
  label: 'transmittal',
  listKey: queryKeys.transmittals.list,
  detailKey: queryKeys.transmittals.detail,
  documentOptionsKey: queryKeys.transmittals.documentOptions,
  list: (jobId, ct) => transmittalApiClient.getTransmittalsByJob(jobId, ct),
  detail: (jobId, id, ct) =>
    transmittalApiClient.getTransmittalById(jobId, id, ct),
  documentOptions: (jobId, ct) =>
    transmittalApiClient.getDocumentOptions(jobId, ct),
});

export const useTransmittalsList = queries.useList;
export const useTransmittal = queries.useDetail;
export const useTransmittalDocumentOptions = queries.useDocumentOptions;
